import { render, staticRenderFns } from "./directReferralEhrform.vue?vue&type=template&id=e73d037e&scoped=true"
import script from "./directReferralEhrform.vue?vue&type=script&lang=js"
export * from "./directReferralEhrform.vue?vue&type=script&lang=js"
import style0 from "./directReferralEhrform.vue?vue&type=style&index=0&id=e73d037e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73d037e",
  null
  
)

export default component.exports